import { AppSettingsType } from '@configs';

interface BaseStateSessionInfoAccountItem {
	accountNumber: string;
	accountName: string;
}

export enum BaseStateSessionInfoCompany {
	AB = 'AB', // Activo Bank
	BCP = 'BCP', // Millennium BCP
}

export enum BaseStateSessionInfoFlow {
	Home = 'Home',
}

export enum BaseStateSessionInfoGeoId {
	Lisbon = '1', // Lisbon
	Porto = '2', // Porto
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface BaseStateSessionInfoConfigs {}

export interface BaseStateSessionInfoImages {
	profile: string;
}

export interface BaseStateSessionInfo {
	interactionId: string;
	sessionId: string;
	tokenOAuth: string; // token OAuth
	alias: string; // user alias
	language: string; // app language
	company: BaseStateSessionInfoCompany; // BCP ou AB
	appMobile: boolean; // app origin from mobile
	mobileSystem: string; // ANDROID or IOS
	targetSystem: string;
	targetInfrastructure: string;
	accountList: BaseStateSessionInfoAccountItem[];
	flow: BaseStateSessionInfoFlow;
	amount?: number;
	term?: number;
	geoId: BaseStateSessionInfoGeoId;
	configs?: BaseStateSessionInfoConfigs;
	images?: BaseStateSessionInfoImages;
	ocpApimSubscriptionKey: string;
	baseUrl?: string;
}

export interface BaseState {
	appSettings: AppSettingsType;
	sessionInfo: BaseStateSessionInfo;
}

export const BaseActionTypes = {};
